<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<app-alert [Type]="AlertType" [View]="AlertStatus" [Message]="AlertMessage"></app-alert>
<div class="mx-5 pb-5">
    <app-pages-header></app-pages-header>
    <div class="bg-white mx-1 bottom-page-shadow rounded-bottom-extra pb-5">
        <div class="row ps-3 pt-4">
            <div class="col">
                <p> <span class="fw-bold">Integrasi</span> - Profil Firma </p>
            </div>
        </div>
        <div class="mx-5 w-50 pt-3">
            <div class="row rounded-top-extra primary-colour shadow ">
                <div class="col pt-2">
                    <p>Butiran Firma</p>
                </div>
            </div>
            <div class="row rounded-bottom-extra shadow" style="background-color: #F5F5F5 !important;">
                <div class="col pt-3">
                    <p class="fs-7 fw-bold">Nama Firma:</p>
                    <p>{{FirmNameView}}</p>
                    <hr/>
                    <p class="fs-7 fw-bold">No. Cukai Firma:</p>
                    <p>{{TaxRefNumView}}</p>
                    <hr/>
                    <p class="fs-7 fw-bold">ID Firma:</p>
                    <p>{{FirmIDView}}</p>
                    <hr/>
                    <p class="fs-7 fw-bold">Tarikh Daftar:</p>
                    <p>{{RegisterDateView}}</p>
                    <hr/>
                </div>
            </div>
        </div>
        </div>
        
</div>
